/**
 * Per-tenant icon override maps consulted by the TUI_ICON_RESOLVER (app.config.ts).
 *
 * This is the brand-neutral default: both maps are empty, so on a standard build the resolver's
 * override branches are no-ops and every tenant keeps the shared Finverity icons. No brand name or
 * brand asset path ships in this file, so nothing tenant-specific leaks into other customers' bundles.
 *
 * A white-label build opts in by swapping this module out via `fileReplacements` in project.json
 * for a variant under that tenant's `white-labeling/` folder, whose maps carry the tenant glyphs.
 * See the swapped-in variant for the two maps' contracts.
 *
 * TENANT_ICON_NAME_OVERRIDES is keyed by icon name (bespoke `fvIcon*` or `@img.*`) and consulted
 * first; TENANT_PHOSPHOR_OVERRIDES is keyed by the phosphor filename the resolver produces.
 */
export const TENANT_ICON_NAME_OVERRIDES: Readonly<Record<string, string>> = {};

export const TENANT_PHOSPHOR_OVERRIDES: Readonly<Record<string, string>> = {};
